import { preloadTopNavigation } from './preloadTopNavigation.ts';

export function preloadAppNavigation() {
	return preloadTopNavigation();
}
